import React, { useState } from 'react';
import TooltipIcon from '../../images/tooltip-icon.svg';
import CountryField from '../CountryField';
import { Link } from 'gatsby';
import { getAccess } from '../Table/columns/mobility.js';

const ModalTooltip = () => {
	return (
		<div
			className="
	modal__content
	--without-margins
	--with-paddings
	bg:light-grey
	mt-2
	mb-2
"
		>
			<div className="modal-row-info">
				<h3>Score</h3>
				<div>
					<p className="mb-2">
						The Enhanced Mobility score goes beyond simply counting
						the number of countries or territories that you have
						access to (from visa-free to restricted access) and also
						measures the desirability of each destination based on
						the quality of life. The Enhanced Mobility Score is
						worth 50% of the Global Passport Index.
					</p>
				</div>
			</div>
		</div>
	);
};

export const MobilityModal = (props) => {
	const { country, mobility_points, iso2c } = props;
	const access = getAccess(props);
	const {
		visa_free_days = 0,
		visa_on_arrival = 0,
		visa_required = 0,
		evisa = 0,
		eta = 0,
		visa_free = 0,
	} = props;
	return {
		HeaderComponent: () => <CountryField code={iso2c} />,
		BodyComponent: () => {
			const [isTooltipVisible, setTooltipVisibility] = useState(false);

			return (
				<main
					className="modal__content pt-0"
					id="filter-continent-content"
				>
					<div className="mb-4">
						<div className="modal-row">
							<h2>
								Enhanced mobility score{' '}
								{!isTooltipVisible && (
									<img
										onClick={() =>
											setTooltipVisibility(true)
										}
										src={TooltipIcon}
									/>
								)}
							</h2>
							<div>{mobility_points}</div>
						</div>
						{isTooltipVisible && <ModalTooltip />}
						<div className="modal-row">
							<h2>Access</h2>
							<div>{access}</div>
						</div>
					</div>

					<div>
						<div className="modal-row">
							<h2>Visa requirements:</h2>
						</div>
						<div className="modal-row">
							<h3>Visa - Free</h3>
							<div className="flex items-center gap-2">
								<div
									className="rating-line"
									style={{
										width:
											visa_free_days +
											visa_free +
											10 +
											'px',
									}}
								></div>
								<span className="w-8">
									{visa_free_days + visa_free}
								</span>
							</div>
						</div>
						<div className="modal-row">
							<h3>Visa on Arrival</h3>
							<div className="flex items-center gap-2">
								<div
									className="rating-line --level-2"
									style={{
										width:
											visa_on_arrival + eta + 10 + 'px',
									}}
								></div>
								<span className="w-8">
									{visa_on_arrival + eta}
								</span>
							</div>
						</div>
						<div className="modal-row">
							<h3>Visa Required</h3>
							<div className="flex items-center gap-2">
								<div
									className="rating-line --level-3"
									style={{ width: visa_required + 10 + 'px' }}
								></div>
								<span className="w-8"> {visa_required} </span>
							</div>
						</div>
					</div>
				</main>
			);
		},
		FooterComponent: () => {
			const countryCode = iso2c?.toLowerCase() || country?.toLowerCase();
			const link = `/countries/${countryCode}`;
			return (
				<Link
					to={link}
					className="modal__btn btn btn__primary"
					aria-label="Close this dialog window"
				>
					Country detail
				</Link>
			);
		},
	};
};
